import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a53a02c2cc25000147c8e7b_1787077113223_72f7bd87/smarck_m/src/app/admin/page.tsx");
